/**
 * FS-14-01 리플레이 재생 — 순수 로직(시험 대상): 타임라인 · 배속 · 재생 방식 표시 · 시간 표시 규칙.
 *  - 시간(경과/전체)은 내 리플레이 또는 교사에게만 — 친구 리플레이의 길이는 곧 친구의 기록이다(DR-01 · SR-LCL-03 · SR-ACH-01).
 *  - 재생 방식: 입력 재생(정본) · 위치 트랙(로컬 PH1 — FE-501 폴백) · 서버 재생(권위 PH2 — 교사에게만).
 *    로컬 리플레이 화면에서는 서버 재생 칩이 늘 흐리다(로컬은 위치 트랙으로 폴백 — 서버 불필요). 권위 리플레이(RoomReplayView)는
 *    FE-501 때 서버 재생으로 넘어간다(SR-REC-02 · ./serverReplay).
 *  - 학생에게는 해시·엔진 정보가 보이지 않는다. FE-501 은 오류가 아니라 '다시 맞춰서 재생해요'.
 */
import type { KernelEvent } from "@picnic-field/local-host/protocol";
import type { PlayState } from "../types";

export const SPEEDS = [0.5, 1, 2] as const;
export type Speed = (typeof SPEEDS)[number];

export const tickToS = (tick: number) => tick / 60;

export function fraction(tick: number, duration: number): number {
  return duration > 0 ? Math.max(0, Math.min(1, tick / duration)) : 0;
}

/** 타임라인 위 x(0~1) → 틱 */
export const tickAt = (frac: number, duration: number) =>
  Math.round(Math.max(0, Math.min(1, frac)) * Math.max(0, duration));

/** 키보드: ←/→ 5초 · PageUp/PageDown 15초 · Home/End */
export function keySeek(key: string, tick: number, duration: number): number | null {
  const step = 5 * 60;
  const big = 15 * 60;
  const clamp = (t: number) => Math.max(0, Math.min(duration, t));
  switch (key) {
    case "ArrowRight":
    case "ArrowUp":
      return clamp(tick + step);
    case "ArrowLeft":
    case "ArrowDown":
      return clamp(tick - step);
    case "PageUp":
      return clamp(tick + big);
    case "PageDown":
      return clamp(tick - big);
    case "Home":
      return 0;
    case "End":
      return duration;
    default:
      return null;
  }
}

/** 시간을 보여도 되는가 — 교사 또는 내 리플레이 */
export const showTimes = (role: "student" | "teacher", mine: boolean) => role === "teacher" || mine;

export const initialPlay = (playback: "input" | "track"): PlayState => ({
  playing: false,
  ended: false,
  playback,
  switched: false,
});

export function onReplayEvent(s: PlayState, e: KernelEvent): PlayState {
  if (e.type === "playback") {
    if (e.mode === s.playback) return s;
    return { ...s, playback: e.mode, switched: s.switched || e.mode === "track" };
  }
  if (e.type === "fe" && e.code === "FE-501") return { ...s, playback: "track", switched: true };
  if (e.type === "playback-end") return { ...s, playing: false, ended: true };
  return s;
}
